module.exports = __webpack_public_path__ + "img/DO.1b05c553.jpg";